


export type DpsRecordType = 'DM' | 'LA' | 'GK' | 'FF';

export const DpsRecordType = {
    DM: 'DM' as DpsRecordType,
    LA: 'LA' as DpsRecordType,
    GK: 'GK' as DpsRecordType,
    FF: 'FF' as DpsRecordType
};

